export default {
  title: "GuangZhou yanxue",

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  showSettings: false,

  updateSettings: "http://realisticgames.zhiying2023.cn/estate/v1/uploadFile",
};
